import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import * as Actions from '../../redux/actions';
import BasicPageComponent from '../BasicPageComponent';
import ScreenContainer from '../ui/ScreenContainer';
import ShowReportGrid from '../ui/ShowReportGrid';
import styles, { styleForReportHeader } from '../../style.js';
import { getProcessReport } from './apiRequestService';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import "../../index.css";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { getParameterByGroupCode } from '../Parameter/apiRequestService';
import DateRangeField from '../ui/DateRangeField';
import PropTypes from 'prop-types';

class ProcessReport extends Component {
  constructor(props) {
    super(props);

    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);

    this.state = {
      status: '',
      beginDateFrom: this.formatDate(oneYearAgo),
      beginDateTo: this.formatDate(today),
      data: [],
      processStatusList: [],
      isLoaded: false,
      isListing: false,
      isExcelLoading: false,
      columns: [
        {
          field: 'corporationNo',
          width: 150,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Müşteri Numarası')
        },
        {
          field: 'corporationName',
          width: 200,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Müşteri Unvan')
        },
        {
          field: 'processName',
          width: 200,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Süreç Adı')
        },
        {
          field: 'createdUser',
          width: 180,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Süreç Oluşturan Kullanıcı')
        },
        {
          field: 'approvers',
          width: 200,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('İmzacı Bilgisi')
        },
        {
          field: 'createdDate',
          width: 180,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Süreç Başlangıç Tarihi'),
          valueFormatter: (params) => this.formatExcelDate(params.value)
        },
        {
          field: 'lastUpdatedDate',
          width: 180,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Süreç Tamamlanma Tarihi'),
          valueFormatter: (params) => this.formatExcelDate(params.value)
        },
        {
          field: 'recordStatus',
          width: 150,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Süreç Durumu')
        },
        {
          field: 'processSubType',
          width: 150,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Süreç Alt Türü')
        },
        {
          field: 'actionId',
          width: 150,
          sortable: false,
          headerAlign: 'center',
          align: 'center',
          renderHeader: () => styleForReportHeader('Süreç Sonu Eylemi')
        }
      ]
    };
  }

  componentDidMount() {
    //Süreç Durumu
    getParameterByGroupCode('PROCESS_STATUS')
      .then((response) => {
        const list = response.data || [];
        const allItem = list.find(x => x.parameterName === 'Tümü');

        this.setState({
          processStatusList: list,
          status: allItem ? allItem.parameterValue : ''
        });
      })
      .catch((exception) => {
        this.props.actions.setNotification("Süreç durumu bilgileri getirilemedi.", 'error');
        console.log('getParameterByGroupCode exception: ' + JSON.stringify(exception));
      });
  }

  formatDate = (date) => {
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
  };

  buildRequest = () => {
    const { status, beginDateFrom, beginDateTo } = this.state;

    return {
      recordStatus: status === "ALL" ? null : status,
      createBeginDate: beginDateFrom,
      createEndDate: beginDateTo
    };
  };

  list = () => {
    const validationMessage = this.validateDateRange();
    const request = this.buildRequest();

    if (validationMessage) {
      this.props.actions.setNotification(validationMessage, 'warning');
      return;
    }

    this.setState({ isListing: true });

    getProcessReport(request)
      .then((response) => {
        this.setState({
          data: response.data || [],
          isLoaded: true
        });
      })
      .catch((exception) => {
        this.props.actions.setNotification(
          'Süreçler Raporu getirilemedi, daha sonra tekrar deneyin.',
          'error'
        );
        console.log('getProcessReport exception: ' + JSON.stringify(exception));
      })
      .finally(() => {
        this.setState({ isListing: false });
      });
  };

  validateDateRange = () => {
    const { beginDateFrom, beginDateTo } = this.state;
  
    const parseApiDate = (value) => {
      if (!value) return null;
      const parts = value.split('-');
      if (parts.length !== 3) return null;
  
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);
  
      const date = new Date(year, month, day);
      if (isNaN(date.getTime())) return null;
  
      date.setHours(0, 0, 0, 0);
      return date;
    };
  
    const addOneYear = (date) => {
      const newDate = new Date(date.getTime());
      newDate.setFullYear(newDate.getFullYear() + 1);
      return newDate;
    };
  
    const getToday = () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return today;
    };
  
    const fromDate = parseApiDate(beginDateFrom);
    const toDate = parseApiDate(beginDateTo);
    const today = getToday();
  
    if (fromDate && fromDate > today) {
      return 'Başlangıç tarihi bugünden büyük olamaz.';
    }
  
    if (toDate && toDate > today) {
      return 'Bitiş tarihi bugünden büyük olamaz.';
    }
  
    if (fromDate && toDate && fromDate > toDate) {
      return 'Başlangıç tarihi, bitiş tarihinden büyük olamaz.';
    }
  
    if (fromDate && toDate) {
      const maxEndDate = addOneYear(fromDate);
      if (toDate > maxEndDate) {
        return 'Tarih aralığı en fazla 1 yıl olabilir.';
      }
    }
  
    return '';
  };

  formatExcelDate = (value) => {
    if (!value) return '';

    const date = new Date(value);

    if (isNaN(date.getTime())) {
      return value;
    }

    const day = (`0${date.getDate()}`).slice(-2);
    const month = (`0${date.getMonth() + 1}`).slice(-2);
    const year = date.getFullYear();
    const hour = (`0${date.getHours()}`).slice(-2);
    const minute = (`0${date.getMinutes()}`).slice(-2);

    return `${day}.${month}.${year} ${hour}:${minute}`;
  };

  downloadExcel = async () => {
    const { data } = this.state;

    if (!data || data.length === 0) {
      this.props.actions.setNotification(
        'Excel oluşturmak için önce listeleme yapmalısınız.',
        'warning'
      );
      return;
    }

    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Süreç Raporu');

      worksheet.columns = [
        { header: 'Müşteri Numarası', key: 'corporationNo', width: 15 },
        { header: 'Müşteri Unvan', key: 'corporationName', width: 15 },
        { header: 'Süreç Adı', key: 'processName', width: 25 },
        { header: 'Süreç Oluşturan Kullanıcı', key: 'createdUser', width: 25 },
        { header: 'İmzacı Bilgisi', key: 'approvers', width: 25 },
        { header: 'Süreç Başlangıç Tarihi', key: 'createdDate', width: 20 },
        { header: 'Süreç Tamamlanma Tarihi', key: 'lastUpdatedDate', width: 20 },
        { header: 'Süreç Durumu', key: 'recordStatus', width: 12 },
        { header: 'Süreç Alt Tipi', key: 'processSubType', width: 20 },
        { header: 'Süreç Sonu Eylemi', key: 'actionId', width: 20 }
      ];
      worksheet.getRow(1).font = { bold: true };

      data.forEach((item) => {
        worksheet.addRow({
          corporationNo: item.corporationNo || '',
          corporationName: item.corporationName || '',
          processName: item.processName || '',
          createdUser: item.createdUser || '',
          approvers: item.approvers || '',
          createdDate: this.formatExcelDate(item.createdDate),
          lastUpdatedDate: this.formatExcelDate(item.lastUpdatedDate),
          recordStatus: item.recordStatus || '',
          processSubType: item.processSubType || '',
          actionId: item.actionId || ''
        });
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob(
        [buffer],
        {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      );

      saveAs(blob, 'EasySign_Surec_Raporu.xlsx');
    } catch (error) {
      console.log('Excel oluşturma hatası:', error);
      this.props.actions.setNotification(
        'Excel oluşturulurken hata oluştu.',
        'error'
      );
    }
  };

  render() {
    const {
      data,
      columns,
      status,
      beginDateFrom,
      beginDateTo,
      isLoaded,
      isListing,
      isExcelLoading,
      processStatusList
    } = this.state;

    return (
      <BasicPageComponent>
        <ScreenContainer>
          <Box sx={{ width: '100%' }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
              <Grid item xs={12}>
                <Box sx={{ ...styles.boxClass, padding: '12px 16px', maxWidth: 950 }}>
                  <div className="headerStyle" style={{ marginBottom: 12 }}>
                    <h4 style={{ margin: 0 }}>Süreçler Raporu</h4>
                  </div>

                  <Grid container spacing={1.5} alignItems="end">
                    <Grid item xs={12} sm={6} md={3}>
                      <InputLabel
                        id="statusLabel"
                        style={{ ...styles.label, marginBottom: 4, fontSize: 15, color: '#18428F' }}
                      >
                        Süreç Durumu
                      </InputLabel>
                      <Select
                        className="customSelect"
                        fullWidth
                        labelId="statusLabel"
                        id="statusSelect"
                        value={status}
                        name="status"
                        onChange={(e) => this.setState({ status: e.target.value })}
                        size="small"
                        style={{ ...styles.selectField, minHeight: 36, fontSize: 15 }}
                        sx={{
                          backgroundColor: '#fff',

                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0,0,0,0.23)'
                          },
                          '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'rgba(0,0,0,0.87)'
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#1976d2'
                          }
                        }}
                      >
                        {processStatusList.map((item) => (
                          <MenuItem key={item.parameterValue} value={item.parameterValue}>
                            <div style={styles.selectField}>{item.parameterName}</div>
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>
                      <DateRangeField
                        label="Süreç Başlangıç Tarihi"
                        fromValue={beginDateFrom}
                        toValue={beginDateTo}
                        onFromChange={(value) => this.setState({ beginDateFrom: value })}
                        onToChange={(value) => this.setState({ beginDateTo: value })}
                        labelStyle={{ ...styles.label, marginBottom: 4, fontSize: 15, color: '#18428F' }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <Button
                        variant="contained"
                        onClick={this.list}
                        disabled={isListing}
                        style={{
                          ...styles.showButton,
                          width: '100%',
                          height: 36,
                          fontSize: 15,
                          padding: '6px 12px',
                          boxShadow: 'none'
                        }}
                      >
                        {isListing ? 'Listeleniyor...' : 'Listele'}
                      </Button>
                    </Grid>

                    <Grid item xs={12} sm={6} md={2}>
                      <Button
                        variant="outlined"
                        onClick={this.downloadExcel}
                        disabled={isExcelLoading}
                        style={{
                          width: '100%',
                          height: 36,
                          fontSize: 13,
                          padding: '6px 12px',
                          boxShadow: 'none',
                          fontFamily: 'Quicksand'
                        }}
                      >
                        {isExcelLoading ? 'Oluşturuluyor...' : 'Excel Oluştur'}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={12}>
                {isLoaded ? (
                  <ShowReportGrid
                    data={data}
                    columns={columns}
                  />
                ) : null}
              </Grid>
            </Grid>
          </Box>
        </ScreenContainer>
      </BasicPageComponent>
    );
  }
}

ProcessReport.propTypes = {
  actions: PropTypes.shape({
    setNotification: PropTypes.func
  })
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  )
)(ProcessReport);